/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

interface IArgs {
  booking: ModelRegistry['booking'];
}

export interface BookingStatusPaymentSignature {
  Element: null;

  Args: IArgs;
}

export default class UiBookingStatusPaymentComponent extends Component<BookingStatusPaymentSignature> {
  @cached
  get booking(): ModelRegistry['booking'] {
    return this.args.booking;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Status::Payment': typeof UiBookingStatusPaymentComponent;
  }
}
